import * as Yup from 'yup';
import { TFunction } from 'i18next';

export const CustomerSearchValidationSchema = (t: TFunction) =>
  Yup.object({
    accountNumber: Yup.string().trim().max(50, 'TooLong'),
    phoneNumber: Yup.string()
      .trim()
      .matches(/^[\d+-]+$/, t('Only digits, +, and - are allowed'))
      .max(30, t('CannotExceedDigits', { digit: 30 })),
    email: Yup.string()
      .trim()
      .email(t('Invalid email'))
      .max(100, t('CannotExceedCharacters', { char: 100 })),
    name: Yup.string()
      .trim()
      .max(100, t('CannotExceedCharacters', { char: 100 })),
    branch: Yup.array().of(Yup.number()).optional(),
  });

export type CustomerSearchValidationSchemaType = ReturnType<
  typeof CustomerSearchValidationSchema
>;
